/**
 * Kaching Bundles -> galerie produit.
 *
 * Kaching masque le sélecteur de variantes du thème et ne met à jour que
 * l'input caché "id" : la galerie n'écoute que le sélecteur du thème, donc
 * l'image ne suivait pas la couleur choisie dans le bundle.
 *
 * On ne relaie PAS le changement au sélecteur du thème : Kaching resynchronise
 * alors toutes les lignes du bundle (#1, #2, #3) sur cette valeur et écrase
 * les choix du client. On fait seulement défiler la galerie jusqu'à l'image
 * de la variante choisie.
 */
(() => {
  if (window.__kachingGallerySync) return;
  window.__kachingGallerySync = true;

  const pathOf = (url) => {
    if (!url) return '';
    try {
      return new URL(url, location.origin).pathname;
    } catch (e) {
      return '';
    }
  };

  const productFor = (block) => {
    const scripts = document.querySelectorAll('script.kaching-bundles-product');
    const main = document.querySelector('script.kaching-bundles-product[data-main="true"]') || scripts[0];
    if (!main) return null;
    try {
      return JSON.parse(main.textContent);
    } catch (e) {
      return null;
    }
  };

  const valuesOf = (row) => {
    const values = {};
    row.querySelectorAll('select[data-name]').forEach((s) => {
      values[s.dataset.name] = s.value;
    });
    row.querySelectorAll('input[data-name]:checked').forEach((i) => {
      values[i.dataset.name] = i.value;
    });
    return values;
  };

  const variantFor = (product, values) => {
    if (!product || !Array.isArray(product.variants)) return null;
    const options = (product.options || []).slice().sort((a, b) => a.position - b.position);
    const names = Object.keys(values);
    if (!names.length) return null;

    const matches = (variant, requireAll) =>
      options.every((opt, i) => {
        if (!(opt.name in values)) return !requireAll;
        return variant.options[i] === values[opt.name];
      });

    return product.variants.find((v) => matches(v, true)) || product.variants.find((v) => matches(v, false)) || null;
  };

  const showImage = (block, imageUrl) => {
    const target = pathOf(imageUrl);
    if (!target) return;
    const section = block.closest('.shopify-section') || document;
    const slider = section.querySelector('product-media-gallery slider-component') ||
      document.querySelector('product-media-gallery slider-component');
    if (!slider) return;

    const slides = slider.querySelectorAll('[data-ref="main-slider"] .splide__list > .splide__slide:not(.splide__slide--clone)');
    let index = -1;
    slides.forEach((slide, i) => {
      if (index !== -1) return;
      const img = slide.querySelector('img');
      if (img && pathOf(img.getAttribute('src')) === target) index = i;
    });
    if (index === -1) return;

    if (slider.slider && typeof slider.slider.go === 'function' && slider.querySelector('.splide.is-initialized')) {
      slider.slider.go(index);
    } else {
      slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  };

  const sync = (block, row) => {
    if (!row) return;
    const variant = variantFor(productFor(block), valuesOf(row));
    if (variant && variant.image) showImage(block, variant.image);
  };

  document.addEventListener('change', (event) => {
    const el = event.target;
    if (!(el instanceof Element)) return;
    const block = el.closest('kaching-bundles-block');
    if (!block) return;

    // Changement de couleur / taille sur une ligne du bundle
    const row = el.closest('.kaching-bundles__bar-variant');
    if (row) {
      sync(block, row);
      return;
    }

    // Changement d'offre (1, 2, 3 produits) : on suit la 1re ligne de l'offre
    if (el.matches('input[type="radio"]')) {
      setTimeout(() => {
        const bar = block.querySelector('.kaching-bundles__bar--selected');
        sync(block, bar && bar.querySelector('.kaching-bundles__bar-variant'));
      }, 60);
    }
  });
})();